import React, { useState } from "react";
import { contributors, dataSources } from "./acknowledgmentsData";

const Acknowledgments = () => {
  const [showAllContributors, setShowAllContributors] = useState(false);
  const [showAllSources, setShowAllSources] = useState(false);

  const toggleContributors = () => setShowAllContributors(!showAllContributors);
  const toggleSources = () => setShowAllSources(!showAllSources);

  const renderItems = (items, showAll, toggleFunction) => {
    const displayItems = showAll ? items : items.slice(0, 3);
    return (
      <>
        {displayItems.map((item, index) => (
          <li key={index} className="text-slate-300">• {item}</li>
        ))}
        {items.length > 3 && (
          <button
            onClick={toggleFunction}
            className="text-[#8fcdb6] hover:text-[#7abfa6] transition-colors duration-300 mt-2"
          >
            {showAll ? "Show Less" : "Show More"}
          </button>
        )}
      </>
    );
  };

  return (
    <section className="bg-gradient-to-b from-[#121B61] to-[#27306f] py-16 sm:py-20">
      <div className="mx-auto px-6 sm:px-10 max-w-7xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Acknowledgments & Attribution
          </h2>
          <p className="text-slate-300 max-w-3xl mx-auto">
            We extend our sincere gratitude to all contributors, researchers, and organizations who have made this dataset possible.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-[#2A3482] hover:bg-[#3C4694] transition-colors duration-300 p-6 rounded-lg">
            <h3 className="text-xl font-semibold text-slate-300 mb-4">Contributors</h3>
            <div className="space-y-4">
              {contributors.map((category, index) => (
                <div key={index}>
                  <h4 className="text-lg font-medium text-slate-300 mb-2">{category.category}</h4>
                  <ul className="space-y-1">
                    {renderItems(category.items, showAllContributors, toggleContributors)}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-[#2A3482] hover:bg-[#3C4694] transition-colors duration-300 p-6 rounded-lg">
            <h3 className="text-xl font-semibold text-slate-300 mb-4">Data Sources</h3>
            <div className="space-y-4">
              {dataSources.map((category, index) => (
                <div key={index}>
                  <h4 className="text-lg font-medium text-slate-300 mb-2">{category.category}</h4>
                  <ul className="space-y-1">
                    {renderItems(category.items, showAllSources, toggleSources)}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-slate-300">
            This dataset is made possible through collaborative efforts and shared knowledge. We encourage proper attribution when using this data in your projects.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Acknowledgments; 